import React, { Component } from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import Anulu from "../images/anulu.webp";


class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: false,
    };
    this.headerRef = React.createRef();
    this.logoRef = React.createRef();
    this.menuRef = React.createRef();

  }


  componentDidMount() {
    this.sticky = this.headerRef.current.offsetTop;
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    
    if (window.pageYOffset > this.sticky) {
      this.headerRef.current.classList.add("sticky-header");
      this.logoRef.current.classList.remove("md:h-24");
      this.logoRef.current.classList.add("md:h-8");
      this.menuRef.current.classList.remove("menu");
    } else {
      this.headerRef.current.classList.remove("sticky-header");
      this.menuRef.current.classList.add("menu");
      this.logoRef.current.classList.remove("md:h-8");
      this.logoRef.current.classList.add("md:h-24");
    }
  }

  handleClick = () => {
    this.setState(state => ({
      isToggleOn: !state.isToggleOn
    }));
  }

  render() {
    return (
        <header ref = { this.headerRef } className="z-10">

          <div className={ this.state.isToggleOn ? "opacity-90" : "" }>
            <nav className="bg-gray-800 shadow-xl py-4">
              <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="relative flex items-center justify-between">
                  <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                    <button
                      type="button"
                      className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={ this.handleClick }
                    >
                      <span className="sr-only">Open main menu</span>
                      <svg
                        className="block h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h16M4 18h16"
                        />
                      </svg>
                      <svg
                        className="hidden h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start"
                  >
                    <div className="flex-shrink-0 flex items-center">
                      <Link to="/">
                        <img 
                          ref = { this.logoRef }
                          className={ this.state.isToggleOn ? "hidden" : "block h-8 md:h-24 w-auto" }
                          width="380"
                          height="90"
                          src={Anulu}
                          alt="Anulu"
                        />
                      </Link>
                    </div>
                    <div className="hidden lg:block sm:ml-6">
                      <div className="flex space-x-4 text-sm font-medium menu" ref = { this.menuRef }>
                        { 
                          this.props.menuLinks.map(link => (
                            <Link 
                              key = { link.link }
                              to = { link.link }
                              className = "hover:bg-gray-700 hover:text-white rounded-md text-gray-300 px-3 py-2"
                              >{ link.name }</Link
                            >
                          ))
                        }
                      </div>
                    </div>
                  </div>
                  { this.props.login.active ?
                    <div
                      className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
                    >
                      <button
                        className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                      >
                        <span className="sr-only">View notifications</span>
                        <svg
                          className="h-6 w-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                          />
                        </svg>
                      </button>

                      <div className="ml-3 relative">
                        <div>
                          <button
                            id="user-menu"
                            type="button"
                            className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                          >
                            <span className="sr-only">Open user menu</span>
                            <img
                              className="h-8 w-8 rounded-full"
                              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                              alt=""
                            />
                          </button>
                        </div>

                        <div
                          v-show="isOpen"
                          className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="user-menu"
                        >
                          <a href="/#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Your Profile</a>
                          <a href="/#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Settings</a>
                          <a href="/#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" role="menuitem">Sign out</a>
                        </div>
                      </div>
                    </div>
                  : <div></div>}
                  </div>
            </div>

            <div id="mobile-menu" className={ !this.state.isToggleOn ? "hidden dm:block" : "opacity-80" }>
              <div className="px-2 pt-2 pb-3 space-y-1">
                { 
                  this.props.menuLinks.map(link => (
                    <Link key = { link.link }
                      to = { link.link }
                      className = "text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-sm font-medium"
                      >{ link.name }</Link
                    >
                  ))
                }

              </div>
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

const header = (props) => (
  <StaticQuery
    query = { graphql`
    query SiteHeaderQuery {
      site {
        siteMetadata {
          menuLinks {
            name
            link
            active
          }
          login {
            active
          }
        }
      }
    }
  `}
  render = { (data) => (<Header menuLinks = { data.site.siteMetadata.menuLinks.filter(menuLink => menuLink.active) } login = { data.site.siteMetadata.login } { ...props } />) }
  />
);

export default header;